module.exports = __webpack_public_path__ + "img/2017_innovation.1dab4e81.jpg";